import {PointCoords} from '@domain/common/common';
import {WGS84DecimalPoint} from '@domain/place/geo.interface';

export class GeoUtil {

  public static toPoint(lon: number, lat: number): PointCoords {
    return {
      type: 'Point',
      coordinates: [lon, lat]
    };
  }

  public static toDecimal(point: PointCoords | WGS84DecimalPoint | null | undefined): WGS84DecimalPoint | null {
    if (!point) {
      return null;
    }
    if (this.isDecimal(point)) {
      return point;
    }
    if (!point?.coordinates || point.coordinates.length < 2) {
      return null;
    }
    return {
      longitude: point.coordinates[0],
      latitude: point.coordinates[1]
    };
  }

  public static isDecimal(point: PointCoords | WGS84DecimalPoint | null | undefined): point is WGS84DecimalPoint {
    const anyPoint = point as any;
    return anyPoint.longitude !== undefined && anyPoint.latitude !== undefined;
  }

  public static isPoint(point: PointCoords | WGS84DecimalPoint | null | undefined): point is PointCoords {
    const anyPoint = point as any;
    return anyPoint.type !== undefined && anyPoint.coordinates !== undefined;
  }

}
